// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2R9_I","right":"Footer_right__3umTo","buttons":"Footer_buttons__1GKyN"};